import { Box, RadioButton } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import {
  FormData,
  ValidMainChurnReasons,
  ValidStepChurn,
} from 'modules/billing/components/DeleteCompanyAction/_DeleteCompanyModal/types'

import SecondaryChurnReason from './SecondaryChurnReason'

type FormProps = {
  step: ValidStepChurn
  getValue: (attr: keyof FormData) => string | undefined
  onChange: (payload: FormData) => void
}

type ChurnReasons = Record<ValidMainChurnReasons, { label: string }>

const FormFields = ({ step, getValue, onChange }: FormProps) => {
  const MAIN_CHURN_REASONS: ChurnReasons = {
    'My company is closing': {
      label: i18n.t('billing.churn_request.options.company_closing.main'),
    },
    "My onboarding wasn't successful": {
      label: i18n.t('billing.churn_request.options.bad_onboarding.main'),
    },
    'I have experienced product issues': {
      label: i18n.t('billing.churn_request.options.product_issues.main'),
    },
    "It's not the solution I need or was expecting": {
      label: i18n.t('billing.churn_request.options.not_needed.main'),
    },
    'Service received by the company was not up to standards': {
      label: i18n.t('billing.churn_request.options.service_received.main'),
    },
    'Management decision': {
      label: i18n.t('billing.churn_request.options.management_decision.main'),
    },
    Other: {
      label: i18n.t('billing.churn_request.options.other.main'),
    },
  }
  const mainReasons = (Object.keys(MAIN_CHURN_REASONS) as (keyof typeof MAIN_CHURN_REASONS)[]).map(
    (value) => ({
      value,
      label: MAIN_CHURN_REASONS[value].label,
    })
  )

  return (
    <>
      {step === 'first-step' && (
        <Box gap="s8">
          {mainReasons.map((reason) => (
            <RadioButton
              key={reason.value}
              onChange={(e) => {
                onChange({ mainReason: e.currentTarget.value, secondaryReason: undefined })
              }}
              value={reason.value}
              checked={getValue('mainReason') === reason.value}
              label={reason.label}
            />
          ))}
        </Box>
      )}
      {step === 'second-step' && getValue('mainReason') && (
        <SecondaryChurnReason
          mainChurnReason={getValue('mainReason') as ValidMainChurnReasons}
          fieldValue={getValue('secondaryReason')}
          fieldOnChange={(secondaryReason) => {
            onChange({ secondaryReason })
          }}
        />
      )}
    </>
  )
}

export default FormFields
